import { useSecuritySetting } from "../store/store";

export const getFirstName = (): string => {
    const { authRequired, msalInstance } = useSecuritySetting.getState();
    if (!authRequired || !msalInstance) return "";
    const name = msalInstance.getAllAccounts()[0]?.name || "";
    return name.match(/\((\w+)\)/)?.[1] || "";
};
